import useUiElementContent from './use-ui-element-content';

export { useUiElementContent };

export default useUiElementContent;
